import { render, staticRenderFns } from "./BprSectionEditor.vue?vue&type=template&id=453d3d88"
import script from "./BprSectionEditor.vue?vue&type=script&lang=ts"
export * from "./BprSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./BprSectionEditor.vue?vue&type=style&index=0&id=453d3d88&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports